import React, { useState } from 'react'
import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline'

interface PasswordInputProps {
  id: string
  label: string
  value: string
  onChange: (value: string) => void
  placeholder?: string
  required?: boolean
  className?: string
}

export default function PasswordInput({
  id,
  label,
  value,
  onChange,
  placeholder = '',
  required = false,
  className = '',
}: PasswordInputProps) {
  const [isVisible, setIsVisible] = useState(false)

  const toggleVisibility = () => {
    setIsVisible(!isVisible)
  }

  const obfuscatedValue = value ? '•'.repeat(Math.min(value.length, 20)) : ''

  return (
    <div className={className}>
      <label
        htmlFor={id}
        className='block text-sm font-medium text-gray-700 dark:text-gray-300'
      >
        {label} {required && '*'}
      </label>
      <div className='relative mt-1'>
        <input
          type={isVisible ? 'text' : 'password'}
          id={id}
          value={isVisible ? value : obfuscatedValue}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className='input pr-10'
        />
        <button
          type='button'
          onClick={toggleVisibility}
          className='absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 dark:text-gray-500 dark:hover:text-gray-300'
        >
          {isVisible ? (
            <EyeSlashIcon className='h-5 w-5' />
          ) : (
            <EyeIcon className='h-5 w-5' />
          )}
        </button>
      </div>
    </div>
  )
}

